(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-stickers"] && !Shopify.designMode) return;
  try {
    
/* Full-circle circular text with tangent orientation + width-aware proportional spacing */
(function () {
  var SECTIONS = document.querySelectorAll('[data-sticker-section]');
  if (!SECTIONS.length) return;

  SECTIONS.forEach(function (ROOT) {
    var WRAP   = ROOT.querySelector('.dfs-sticker');
    var RING   = ROOT.querySelector('.dfs-sticker--circle .sticker');
    var IMG    = ROOT.querySelector('.dfs-sticker--circle .submark img');
    var BTN    = ROOT.querySelector('.dfs-sticker-trigger');
    var MODAL  = ROOT.querySelector('.dfs-modal');
    var PANEL  = MODAL ? MODAL.querySelector('.dfs-modal__panel') : null;
    var CLOSES = MODAL ? MODAL.querySelectorAll('[data-close]') : [];

    // Modal wiring works for both sticker styles.
    var lastFocused = null;

    function openModal() {
      if (!MODAL) return;
      lastFocused = document.activeElement;
      MODAL.classList.add('is-open');
      MODAL.setAttribute('aria-hidden', 'false');
      if (PANEL) PANEL.focus();
      document.addEventListener('keydown', onKey);
      if (BTN) BTN.setAttribute('aria-expanded', 'true');
    }

    function closeModal() {
      if (!MODAL) return;
      MODAL.classList.remove('is-open');
      MODAL.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', onKey);
      if (BTN) {
        BTN.setAttribute('aria-expanded', 'false');
        BTN.focus();
      } else if (lastFocused) {
        lastFocused.focus();
      }
    }

    function onKey(e) {
      if (e.key === 'Escape') closeModal();
    }

    if (BTN && MODAL && BTN.tagName === 'BUTTON') {
      BTN.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();
      });
    }

    (CLOSES || []).forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    // Only run the circular text builder when this is the rotating circle sticker.
    if (!WRAP || !RING || !IMG) return;

    // Cache raw text.
    if (!RING.hasAttribute('data-raw')) {
      RING.setAttribute('data-raw', (RING.textContent || '').trim());
    }

    // Canvas measurer using element's computed font.
    function makeMeasurer(el) {
      var c = document.createElement('canvas');
      var ctx = c.getContext('2d');
      var cs = getComputedStyle(el);
      var font = [
        cs.fontStyle || 'normal',
        cs.fontVariant || 'normal',
        cs.fontWeight || '400',
        cs.fontSize || '16px',
        cs.lineHeight && cs.lineHeight !== 'normal' ? '/' + cs.lineHeight : '',
        cs.fontFamily || 'sans-serif'
      ].join(' ').replace(/\s+/g,' ').trim();

      ctx.font = font;
      return function (ch) {
        return ctx.measureText(ch).width;
      };
    }

    function cssNumber(varName, fallback) {
      var v = getComputedStyle(WRAP).getPropertyValue(varName).trim();
      var n = parseFloat(v);
      return isNaN(n) ? fallback : n;
    }

    function build() {
      var text = RING.getAttribute('data-raw') || '';
      if (!text.length) return;

      var imgW = IMG.getBoundingClientRect().width;
      if (!imgW) {
        requestAnimationFrame(build);
        return;
      }

      var gapPx = cssNumber('--ring-gap', 12);
      var tracking = cssNumber('--ring-tracking', 0);
      var startDeg = cssNumber('--ring-start-deg', -90);
      var direction = cssNumber('--ring-direction', 1) >= 0 ? 1 : -1;
      var baselinePad = cssNumber('--ring-offset', 2);

      var R = (imgW / 2) + gapPx + baselinePad;
      var D = Math.ceil(R * 2);

      WRAP.style.setProperty('--ring-diameter', D + 'px');
      RING.style.width = D + 'px';
      RING.style.height = D + 'px';

      var measure = makeMeasurer(RING);
      var chars = Array.from(text);
      var widths = chars.map(function (ch) {
        return ch === ' ' ? measure('·') * 0.45 : measure(ch);
      });

      var totalW = widths.reduce(function (sum, width) {
        return sum + width + tracking;
      }, 0);

      if (!totalW) return;

      RING.innerHTML = '';

      var startRad = startDeg * Math.PI / 180;
      var accum = 0;

      for (var i = 0; i < chars.length; i++) {
        var w = widths[i] + tracking;
        var frac = w / totalW;
        var sweepRad = frac * Math.PI * 2;
        var midRad = startRad + direction * (accum + sweepRad / 2);
        var angleDeg = midRad * 180 / Math.PI;

        var span = document.createElement('span');
        span.textContent = chars[i];
        span.style.transform =
          'rotate(' + angleDeg + 'deg) translate(' + R + 'px) rotate(' + (90 * direction) + 'deg)';

        RING.appendChild(span);
        accum += sweepRad;
      }
    }

    if (IMG.complete) build();
    else IMG.addEventListener('load', build, { once: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(build, 120);
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(build).observe(IMG);
    }

    document.addEventListener('df:rebuild-sticker', function (e) {
      if (e && e.detail && e.detail.root && e.detail.root !== ROOT) return;
      build();
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
